<div
  class="mainContainerStyle"
>
  <div
    class="getScrollBarIntoAccount"
  >
<!--    <b>Администрирование встречи</b>-->

    <div
      class="namesMobileSection"
    >
      <div
        class="firstButtonSection"
      >
        <div
          class="namesTextStyle"
        >
          {{this.duelSeries.player_one.full_name}}
        </div>
<!--        <div>-->
<!--          <app-player-replacer-->
<!--            *ngIf="!duelSeries.group"-->
<!--            [currentDuelId]="duelSeries?.number"-->
<!--            [currentPlayerId]="duelSeries?.player_one?.id"-->
<!--          >-->
<!--          </app-player-replacer>-->
<!--        </div>-->
      </div>
      <div
        class="lastButtonSection"
      >
        <div
          class="namesTextStyle"
        >
          {{this.duelSeries.player_two.full_name}}
        </div>
<!--          <app-player-replacer-->
<!--            *ngIf="!duelSeries.group"-->
<!--            [currentDuelId]="duelSeries?.number"-->
<!--            [currentPlayerId]="duelSeries?.player_two?.id"-->
<!--            style="display: flex; justify-content: flex-end"-->
<!--          >-->
<!--          </app-player-replacer>-->
      </div>
    </div>
    <div
      class="tableDivMobile"
      *ngIf="duelSeries.previewDuels?.length || duelSeries.duels?.length"
    >
      <table class="table">
        <thead
          class="tHeadMobile"
        >
        <tr>
          <th
            colspan="3"
            class="align-center tHeadCellPaddingsCleanerMobile"
            scope="col"
          >
            <div
              class="tHeadDivMobile"
            >
              Результаты партий
            </div>
          </th>
        </tr>
        </thead>
        <tbody>

        <tr *ngFor="let duel of duelSeries.previewDuels && duelSeries.previewDuels.length ? duelSeries.previewDuels : duelSeries.duels">
          <td>
            <div class="d-flex justify-content-center">
              <a href="javascript:void(0)" (click)="decrementDuelScore(duel, 1)" *ngIf="duel.id && controlsAvailable()" class="pt-1"><i class="fa-solid fa-chevron-left"></i></a>
              <div [class.cell-bordered-prim_color]="duel.player_one_score > duel.player_two_score" [class.cell-bordered]="duel.player_one_score <= duel.player_two_score">{{ duel.player_one_score }}</div>
              <a href="javascript:void(0)" (click)="incrementDuelScore(duel, 1)" *ngIf="duel.id && controlsAvailable()" class="pt-1"><i class="fa-solid fa-chevron-right"></i></a>
            </div>
          </td>
          <td>
            <div class="cell">Партия {{ duel.number }}</div>
            <div class="cell"><a href="javascript: void(0)" class="text-danger" (click)="deleteDuel(duel.id)" *ngIf="duel.id && controlsAvailable()">Удалить</a></div>
          </td>
          <td>
            <div class="d-flex justify-content-center">
              <a href="javascript:void(0)" (click)="decrementDuelScore(duel, 2)" *ngIf="duel.id && controlsAvailable()" class="pt-1"><i class="fa-solid fa-chevron-left"></i></a>
              <div [class.cell-bordered-prim_color]="duel.player_one_score < duel.player_two_score" [class.cell-bordered]="duel.player_one_score >= duel.player_two_score">{{ duel.player_two_score }}</div>
              <a href="javascript:void(0)" (click)="incrementDuelScore(duel, 2)" *ngIf="duel.id && controlsAvailable()" class="pt-1"><i class="fa-solid fa-chevron-right"></i></a>
            </div>
          </td>
        </tr>

<!--        <tr>-->
<!--          <td colspan="3" scope="col" class="text-center">-->
<!--            <button-->
<!--              type="button"-->
<!--              class="btn btn-primary btn-sm"-->
<!--              (click)="addDuel()"-->
<!--            >-->
<!--              Добавить партию-->
<!--            </button>-->
<!--          </td>-->
<!--        </tr>-->
        </tbody>
      </table>
    </div>
    <div class="addPartySectionMobile">
      <button
        type="button"
        class="btn btn-primary btn-sm"
        (click)="addDuel()"
      >
        Добавить партию
      </button>
    </div>
    <div class="row">
      <div class="col div-cenered">
        <button
          type="button"
          class="btn btn-sm"
          *ngIf="controlsAvailable()"
          (click)="decrementDuelSeriesScore(1)"
        >
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        <input
          style="min-width: 40px; text-align: center"
          type="text" name="player-one-score-mobile"
          id="player-one-score-mobile"
          class="form-control"
          *ngIf="controlsAvailable()"
          [formControl]="playerOneScore"
        />
        <button
          type="button"
          class="btn btn-sm"
          *ngIf="controlsAvailable()"
          (click)="incrementDuelSeriesScore(1)"
        >
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>

      <div class="col d-none d-lg-flex"></div>

      <div class="col div-cenered">

        <button
          type="button"
          class="btn btn-sm"
          *ngIf="controlsAvailable()"
          (click)="decrementDuelSeriesScore(2)"
        >
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        <input
          style="min-width: 40px; text-align: center"
          type="text"
          name="player-two-score-mobile"
          id="player-two-score-mobile"
          class="form-control"
          *ngIf="controlsAvailable()"
          [formControl]="playerTwoScore"
        />
        <button
          type="button"
          class="btn btn-sm"
          *ngIf="controlsAvailable()"
          (click)="incrementDuelSeriesScore(2)"
        >
          <i class="fa-solid fa-chevron-right"></i>
        </button>

      </div>

    </div>

    <div
      class="row mt-5 hiderOfAdminScoreButtonsMobile"
      *ngIf="controlsAvailable()"
    >

      <div class="col-12 text-center align-self-center">
        <input
          type="text"
          name="result"
          id="result-mobile"
          class="form-control"
          placeholder="Пример: 8-3 5-2"
          [formControl]="duelsInput"
        />
      </div>

      <div
        class="col-12 text-center mt-2"
        *ngIf="duelSeries.previewDuels"
      >

        <button
          class="btn btn-primary btn-sm"
          (click)="save()"
        >
          Сохранить
        </button>
        <br />
        <span class="text-muted fs12">Все партии обновятся, счет перерасчитается</span>

      </div>

    </div>
    <div class="row pb-2">

      <div class="col">
        Статус встречи: {{ getStatus() }}
        <i style="cursor: pointer" class="fa-solid fa-play ms-3 text-primary" (click)="start()" title="Начать игру" *ngIf="duelSeries.status == 'scheduled'"></i>
        <i style="cursor: pointer" class="fa-solid fa-pause ms-3 text-secondary" (click)="pause()" title="Пауза" *ngIf="duelSeries.status == 'in_progress'"></i>
        <i
          style="cursor: pointer"
          class="fa-solid fa-repeat ms-3 text-primary"
          (click)="pause()"
          title="Открыть встречу"
          *ngIf="duelSeries.status == 'finished' && duelCanBeReplayed()"
        ></i>
        <i style="cursor: pointer" class="fa-solid fa-stop ms-3 text-danger" (click)="stop()" title="Завершить встречу" *ngIf="duelSeries.status == 'in_progress'"></i>
      </div>

    </div>

    <div
      class="tableAndWinScore"
    >
      <div class="row pb-2" *ngIf="tables && view != 'tablet'">
        <div class="col">
          <label
            for="table-select"
          >
            Cтол: <b>{{ duelSeries.table?.number }}</b>
          </label>

          <a
            href="/tournament/{{ duelSeries.tournament_id }}/table/{{ duelSeries.table.id }}/judge"
            *ngIf="duelSeries.table"
            target="_blank" class="ms-2 me-2 text-primary"
            title="Судейский планшет"
          >
            <i class="fa-solid fa-tablet-screen-button"></i>
          </a>
          <a
            href="{{ duelSeries.table.youtube_link }}"
            *ngIf="duelSeries.table && duelSeries.table.youtube_link"
            target="_blank" class="text-danger"
            title="Плашка для трансляции"
          >
            <i class="fa-solid fa-video"></i>
          </a>

          <select class="form-control" (change)="assignTable($event)" id="table-select" style="outline: none">
            <option>{{ duelSeries.table ? "Изменить стол" : "Выберите стол" }}</option>
            <option *ngIf="duelSeries.table" [value]=""></option>
            <option *ngFor="let table of tables" [selected]="duelSeries.table_number == table.number" [value]="table.number">Стол #{{ table.number }}</option>
          </select>
        </div>
      </div>
      <div
        class="winsScoreDiv"
      >
        <div class="row pb-2 winsScore">
          <div class="col">До побед:</div>
        </div>

        <div
          class="row pb-2 winsScore"
          *ngIf="tables && view != 'tablet'"
        >
          <div class="col-auto">
            <input
              style="min-width: 50px"
              type="text"
              name="wins_count"
              id="wins_count"
              class="form-control"
              [formControl]="winsCount"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row pb-2" *ngIf="duelSeries.status == 'scheduled'">
      <div class="col">Планируемые дата и время встречи:</div>
    </div>

    <div
      class="row pb-2"
      *ngIf="tables && view != 'tablet' && duelSeries.status == 'scheduled'"
    >
      <div class="dateTimePickerSection">
        <div class="col-auto dateInput">
          <input
            type="text"
            name="scheduled_at_date"
            ngbDatepicker #d="ngbDatepicker"
            id="scheduled_at_date"
            [(ngModel)]="scheduledAtDate"
            [ngModelOptions]="{ standalone: true }"
            (click)="d.toggle()"
          />
        </div>
        <div class="col-auto timePickerOffset">
          <ngb-timepicker
            [(ngModel)]="scheduledAtTime"
            [spinners]="false"
            [ngModelOptions]="{ standalone: true }"
            [size]="'small'"
          ></ngb-timepicker>
        </div>
      </div>
      <div class="col">
        <button
          class="btn btn-sm btn-primary"
          (click)="saveScheduledTime()"
        >
          Сохранить время
        </button>
      </div>
    </div>



    <div class="row pb-2">
      <div class="col">Ссылка на YouTube:</div>
    </div>

    <div class="row pb-2" *ngIf="view != 'tablet'">
      <div class="col">
        <input
          type="text"
          name="youtube_link"
          id="youtube_link"
          class="form-control"
          [formControl]="youtubeLink"
        />
      </div>
    </div>

    <div class="row pb-2">
      <div class="col">
        <a
          href="/tournament/{{ duelSeries.tournament_id }}/duel_series/{{ id }}/print"
          target="_blank"
        >
          <i class="fa-solid fa-print"></i> Печать протокола
        </a>
      </div>
    </div>
  </div>
</div>
